<template>
  <div class="page2">
    <el-scrollbar always>
      <div class="page2-content">
        <h1>印花税税源采集表</h1>

        <div class="page2-list">
          <dl>
            <dt>
              <el-button type="primary">一键零申报</el-button>
              <el-button plain @click="add" type="primary">新增税源</el-button>
              <el-button plain type="primary">导入</el-button>
            </dt>
            <dd>金额单位：元，至角分</dd>
          </dl>

          <template v-if="!isEdit">
            <el-table :data="props.data" border :header-cell-style="{ 'text-align': 'center', 'background-color': '#f6f8fa', color: '#323232' }" :cell-style="{ 'text-align': 'center' }">
              <el-table-column label="序号" type="index" width="80px" />
              <el-table-column label="税目" prop="taxItems">
                <template #default="{ row, $index }">
                  {{ (taxItemsFind(row.taxItems) || {}).label }}
                </template>
              </el-table-column>
              <el-table-column label="申报期限类型" prop="taxType">
                <template #default="{ row, $index }">
                  {{ (taxTypeFind(row.taxType) || {}).label }}
                </template>
              </el-table-column>
              <el-table-column label="税款所属期起" prop="startTime" />
              <el-table-column label="税款所属期止" prop="endTime" />
              <el-table-column label="计税金额" prop="taxableAmount">
                <template #default="{ row, $index }">
                  {{ parseFloatNum(row.taxableAmount) }}
                </template>
              </el-table-column>
              <el-table-column label="税率" prop="taxRate" />
              <el-table-column label="应纳税额" prop="amountPayable">
                <template #default="{ row, $index }">
                  {{ parseFloatNum(row.amountPayable) }}
                </template>
              </el-table-column>
              <el-table-column label="减免税额" prop="taxReduces">
                <template #default="{ row, $index }">
                  {{ parseFloatNum(row.taxReduces) }}
                </template>
              </el-table-column>
              <el-table-column label="应补(退)税额" prop="taxPayment">
                <template #default="{ row, $index }">
                  {{ parseFloatNum(row.taxPayment) }}
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template #default="{ row, $index }">
                  <el-button link @click="edit(row, $index)">修改</el-button>
                  <el-button link @click="del(row, $index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

            <div class="fix-wrap-b" v-if="props.data.length > 0">
              <div style="justify-content: center">
                <el-button plain @click="goBack">退出</el-button>
                <el-button type="primary" @click="submit">提交</el-button>
              </div>
            </div>
          </template>

          <div v-else>
            <el-form :model="formData" ref="formRef" :rules="formRules" label-suffix="：" label-width="auto" :inline="true" @keyup.enter="formSubmit">
              <table width="100%" cellspacing="0" cellpadding="0" class="table-form">
                <tbody>
                  <tr>
                    <td>
                      <el-form-item required label="税款所属期起" prop="startTime">
                        <el-input placeholder="请输入" :value="formData.startTime" readonly />
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item required label="税款所属期止" prop="endTime">
                        <el-input placeholder="请输入" :value="formData.endTime" readonly />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item required label="申报期限类型" prop="taxType">
                        <el-select v-model="formData.taxType" placeholder="请选择">
                          <el-option v-for="(item, index) of taxTypeOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item required label="应税凭证名称" prop="taxVoucher">
                        <el-input placeholder="请输入" v-model.trim="formData.taxVoucher" />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item required label="税目" prop="taxItems">
                        <el-select v-model="formData.taxItems" placeholder="请选择">
                          <el-option v-for="(item, index) of taxItemsOpionts" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="子目" prop="taxChildrenItems">
                        <el-select v-model="formData.taxChildrenItems" placeholder="请选择">
                          <el-option v-for="(item, index) of taxChildrenItemsOpionts" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item required label="计税金额" prop="taxableAmount">
                        <el-input-number placeholder="请输入" style="width: 100%" v-model.trim="formData.taxableAmount" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item required label="税率" prop="taxRate">
                        <el-input placeholder="请输入" :value="formData.taxRate" readonly />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item required label="应纳税额" prop="amountPayable">
                        <el-input-number placeholder="请输入" readonly style="width: 100%" v-model.trim="formData.amountPayable" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="减免性质代码和项目名称" prop="taxCode">
                        <el-input placeholder="请输入" v-model.trim="formData.taxCode" />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item label="减免税额" prop="taxReduces">
                        <el-input-number placeholder="请输入" readonly style="width: 100%" v-model.trim="formData.taxReduces" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item required label="应税凭证书立日期" prop="taxableDate">
                        <el-date-picker type="date" style="width: 100%" :clearable="false" v-model="formData.taxableDate" placeholder="请选择" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <el-form-item required label="应税凭证数量" prop="taxableNum">
                        <el-input placeholder="请输入" v-model.trim="formData.taxableNum" />
                      </el-form-item>
                    </td>
                    <td>
                      <el-form-item label="应税凭证编号" prop="taxableNo">
                        <el-input placeholder="请输入" v-model.trim="formData.taxableNo" />
                      </el-form-item>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" align="center" style="padding: 20px">
                      <el-button @click="cancel">取消</el-button>
                      <el-button type="primary" @click="formSubmit">保存</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </el-form>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script setup>
import { $emit, $on } from "vue-happy-bus";
import Big from "big.js";
import { cloneDeep } from "lodash";
import {reportTaxDateConfig} from "@/views/examCenter/reportTax/reportTaxStaticConfig.js";

const currentQa = inject('provideCurrentQa');
const {staticConfig} = reportTaxDateConfig(currentQa.value)

const props = defineProps({
  data: {
    default: () => [],
  },
  status: {
    default: 0,
  },
});

const formData = ref({});

const isEdit = ref(false);
const add = () => {
  if (isEdit.value) {
    return;
  }

  formData.value = {
    startTime: staticConfig.taxStartTime,
    endTime: staticConfig.taxEndTime,
    taxType: "",
    taxVoucher: "",
    taxItems: "",
    taxChildrenItems: "",
    taxableAmount: null,
    taxRate: "",
    amountPayable: 0,
    taxCode: "",
    taxReduces: 0,
    taxableDate: "",
    taxableNum: "",
    taxableNo: "",
    taxPayment: "",
  };

  isEdit.value = true;
};

const editIndex = ref(null);
const edit = (row, index) => {
  editIndex.value = index;
  formData.value = cloneDeep(props.data[editIndex.value]);

  isEdit.value = true;
};

const del = (row, index) => {
  ElMessageBox.confirm("确认删除", "提示").then((res) => {
    const data = cloneDeep(props.data);
    data.splice(index, 1);

    emits("updateData", {
      status: 0,
      data,
    });
  });
};

const cancel = () => {
  isEdit.value = false;
  editIndex.value = null;
  formData.value = {};
};

$on("saveQaSuccessYhs", () => {
  cancel();
});

const formRules = reactive({
  startTime: [{ required: true, message: "请选择税款所属期起", trigger: ["change", "blur"] }],
  endTime: [{ required: true, message: "请选择税款所属期止", trigger: ["change", "blur"] }],
  taxType: [{ required: true, message: "请选择申报期限类型", trigger: ["change", "blur"] }],
  taxVoucher: [{ required: true, message: "请输入应税凭证名称", trigger: ["change", "blur"] }],
  taxItems: [{ required: true, message: "请选择税目", trigger: ["change", "blur"] }],
  // taxChildrenItems: [{ required: true, message: "请选择子目", trigger: ["change", "blur"] }],
  taxableAmount: [{ required: true, message: "请输入计税金额", trigger: ["change", "blur"] }],
  taxRate: [{ required: true, message: "请输入税率", trigger: ["change", "blur"] }],
  amountPayable: [{ required: true, message: "请输入应纳税额", trigger: ["change", "blur"] }],
  // taxCode: [{ required: true, message: "请输入减免性质代码和项目名称", trigger: ["change", "blur"] }],
  // taxReduces: [{ required: true, message: "请输入减免税额", trigger: ["change", "blur"] }],
  taxableDate: [{ required: true, message: "请选择应税凭证书立日期", trigger: ["change", "blur"] }],
  taxableNum: [{ required: true, message: "请输入应税凭证数量", trigger: ["change", "blur"] }],
  // taxableNo: [{ required: true, message: "请输入应税凭证编号", trigger: ["change", "blur"] }],
});

const formRef = ref();
const formSubmit = async () => {
  formRef.value.validate((valid) => {
    if (!valid) {
      return;
    }

    const data = cloneDeep(props.data);

    if (editIndex.value != null) {
      // 编辑
      data.splice(editIndex.value, 1, toRaw(formData.value));
    } else {
      // 新增
      data.push(toRaw(formData.value));
    }

    emits("updateData", {
      status: 0,
      data,
    });
  });
};

const submit = () => {
  goBack();
  emits("taxSubmitShow");
};

const taxTypeFind = (taxType) => {
  return taxTypeOptions.find((item) => item.value == taxType);
};

const taxItemsFind = (taxItems) => {
  return taxItemsOpionts.find((item) => item.value == taxItems);
};

watch(
  () => formData.value.taxItems,
  () => {
    if (!isEdit.value) {
      return;
    }

    try {
      const taxItemsFindItem = taxItemsFind(formData.value.taxItems);

      if (taxItemsFindItem) {
        formData.value.taxRate = taxItemsFindItem.rate;
        formData.value.amountPayable = new Big(formData.value.taxableAmount ?? 0).times(formData.value.taxRate).round(2).toNumber();
        formData.value.taxPayment = formData.value.amountPayable;

        formData.value.taxChildrenItems = "";
        taxChildrenItemsOpionts.value = taxItemsFindItem.options;
      }
    } catch (e) {
      console.log(e);
    }
  },
  {
    immediate: true,
  }
);

watch(
  () => formData.value.taxableAmount,
  () => {
    if (!isEdit.value) {
      return;
    }

    try {
      formData.value.amountPayable = new Big(formData.value.taxableAmount ?? 0).times(formData.value.taxRate).round(2).toNumber();
      formData.value.taxPayment = formData.value.amountPayable;
    } catch (e) {
      console.log(e);
    }
  },
  {
    immediate: true,
  }
);

const emits = defineEmits(["goBack", "gotoNext", "updateData", "taxSubmitShow", "taxSubmit"]);

const goBack = () => {
  emits("goBack");
};

const taxChildrenItemsOpionts = ref([]);

const taxTypeOptions = [
  {
    label: "请选择",
    value: "",
  },
  {
    label: "按次申报",
    value: "1",
  },
  {
    label: "按期申报",
    value: "2",
  },
];

const taxItemsOpionts = [
  { label: "请选择", value: "", rate: "0.00", options: [{ label: "请选择", value: "" }] },
  {
    label: "借款合同",
    value: "1",
    rate: "0.00005",
    options: [
      { label: "请选择", value: "" },
      { label: "银行业金融机构借款合同", value: "1-1" },
      { label: "其他金融机构借款合同", value: "1-2" },
    ],
  },
  { label: "融资租赁合同", value: "2", rate: "0.00005", options: [{ label: "请选择", value: "" }] },
  { label: "买卖合同", value: "3", rate: "0.0003", options: [{ label: "请选择", value: "" }] },
  {
    label: "承揽合同",
    value: "4",
    rate: "0.0003",
    options: [
      { label: "请选择", value: "" },
      { label: "加工合同", value: "4-1" },
      { label: "定作合同", value: "4-2" },
      { label: "修理合同", value: "4-3" },
      { label: "复制合同", value: "4-4" },
      { label: "测试合同", value: "4-5" },
      { label: "检验合同", value: "4-6" },
    ],
  },
  {
    label: "建设工程合同",
    value: "5",
    rate: "0.0003",
    options: [
      { label: "请选择", value: "" },
      { label: "工程勘察合同", value: "5-1" },
      { label: "工程设计合同", value: "5-2" },
      { label: "工程施工合同", value: "5-3" },
    ],
  },
  {
    label: "运输合同",
    value: "6",
    rate: "0.0003",
    options: [
      { label: "请选择", value: "" },
      { label: "公路货物运输合同", value: "6-1" },
      { label: "水路货物运输合同", value: "6-2" },
      { label: "航空货物运输合同", value: "6-3" },
      { label: "铁路货物运输合同", value: "6-4" },
      { label: "多式联运合同", value: "6-5" },
    ],
  },
  {
    label: "技术合同",
    value: "7",
    rate: "0.0003",
    options: [
      { label: "请选择", value: "" },
      { label: "技术开发合同", value: "7-1" },
      { label: "技术许可合同", value: "7-2" },
      { label: "技术咨询合同", value: "7-3" },
      { label: "技术服务合同", value: "7-4" },
    ],
  },
  {
    label: "租赁合同",
    value: "8",
    rate: "0.001",
    options: [
      { label: "请选择", value: "" },
      { label: "房屋租赁合同", value: "8-1" },
      { label: "其他租赁合同", value: "8-2" },
    ],
  },
  {
    label: "保管合同",
    value: "9",
    rate: "0.001",
    options: [{ label: "请选择", value: "" }],
  },
  { label: "仓储合同", value: "10", rate: "0.001", options: [{ label: "请选择", value: "" }] },
  { label: "财产保险合同", value: "11", rate: "0.001", options: [{ label: "请选择", value: "" }] },
  {
    label: "产权转移书据",
    value: "12",
    rate: "0.00",
    options: [
      { label: "请选择", value: "" },
      { label: "土地使用权出让书据", value: "12-1" },
      { label: "土地使用权转让书据", value: "12-2" },
      { label: "房屋等建筑物和构筑物所有权转让书据（不包括土地承包经营权和土地经营权转移）", value: "12-3" },
      { label: "股权转让书据（不包括应缴纳证券交易印花税的）", value: "12-4" },
      { label: "商标专用权转让书据", value: "12-5" },
      { label: "著作权转让书据", value: "12-6" },
      { label: "专利权转让书据", value: "12-7" },
      { label: "专有技术使用权转让书据", value: "12-8" },
    ],
  },
  { label: "营业账簿", value: "13", rate: "0.00025", options: [{ label: "请选择", value: "" }] },
];

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {
    return s;
  }
}
</script>

<style scoped lang="scss">
.page2 {
  height: 100%;
  background-color: #ffffff;
  padding: 0 16px;

  .page2-content {
    > h1 {
      width: 100%;
      padding-top: 16px;
      padding-bottom: 16px;
      line-height: 36px;
      text-align: center;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      text-align: center;
      background-color: #f9fafd;
      border-radius: 2px;
      line-height: 1;
      flex: 0 0 auto;
    }

    .page2-list {
      padding: 16px;

      > dl {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .table-form {
        width: 100%;
        font-size: 14px;
        border-color: rgb(220, 220, 220);
        border-collapse: collapse;
        border-spacing: 1px;

        td {
          padding: 8px 4px;
        }

        .el-form-item {
          width: 80%;
        }

        :deep(.el-input__inner) {
          text-align: left;
        }
      }
    }
  }
}
</style>
